import React from 'react';
import { ButtonBase, Chip, Stack, SxProps } from '@mui/material';

import { TP_COLORS } from '../../../../constants';
import { ISectionForUser } from '../../../../store/V2/SectionSlice';
import { getClassShortUrlByWaitingId } from '../../../../helper';
import ZoomSectionItem, { getZoomRequestStatusColor } from './ZoomSectionItem';
import ZoomMeetingOptionsButtonWithMenu from './ZoomMeetingOptionsButtonWithMenu';
import {
  ZOOM_MEETING_REQUEST_STATUSES,
  ZOOM_MEETING_REQUEST_TYPES,
} from '../../../../store/V2/ZoomRequestsSlice';

interface MixedSectionContentProps {
  zoomData?: ISectionForUser;
  resourceData?: ISectionForUser;
  isCourseSubscribed?: boolean;
  isOneToOne: boolean;
  onCancelClass: (section: ISectionForUser) => void;
  onRescheduleClass: (section: ISectionForUser) => void;
}

const buttonBaseStyles: SxProps = {
  p: '8px',
  borderRadius: '5px',
  fontSize: '12px',
  fontWeight: 600,
};

const MixedSectionContent: React.FC<MixedSectionContentProps> = ({
  zoomData,
  resourceData,
  isCourseSubscribed,
  isOneToOne,
  onCancelClass,
  onRescheduleClass,
}) => {
  let classLink = '';

  const isZoomRequestCanceled =
    zoomData &&
    zoomData.zoomRequest &&
    zoomData.zoomRequest.type === ZOOM_MEETING_REQUEST_TYPES.CANCEL &&
    zoomData.zoomRequest.status === ZOOM_MEETING_REQUEST_STATUSES.APPROVED;

  const isZoomRequestNotPending = !(
    zoomData &&
    zoomData.zoomRequest &&
    zoomData.zoomRequest.status === ZOOM_MEETING_REQUEST_STATUSES.PENDING
  );

  if (
    isCourseSubscribed &&
    zoomData &&
    zoomData.classWaitingId &&
    !isZoomRequestCanceled &&
    isZoomRequestNotPending
  ) {
    classLink = getClassShortUrlByWaitingId(zoomData.classWaitingId);
  }

  return (
    <Stack gap={2} style={{ marginBottom: '15px' }}>
      {zoomData ? (
        <Stack gap={2}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Chip
              size="small"
              label="Zoom"
              color="info"
              sx={{ width: 'fit-content' }}
            />
            {zoomData.zoomRequest && isCourseSubscribed ? (
              <Chip
                size="small"
                label={`${zoomData.zoomRequest.type} - ${zoomData.zoomRequest.status}`}
                color={getZoomRequestStatusColor(zoomData.zoomRequest.status)}
                sx={{ width: 'fit-content' }}
              />
            ) : null}
          </Stack>
          <ZoomSectionItem
            section={zoomData}
            innerContentOnly
            onCancelClass={onCancelClass}
            isOneToOne={isOneToOne}
            onRescheduleClass={onRescheduleClass}
          />
        </Stack>
      ) : null}
      <Stack direction="row" alignItems="center" gap={1}>
        {classLink ? (
          <ButtonBase
            href={classLink}
            target="_blank"
            sx={{
              ...buttonBaseStyles,
              backgroundColor: '#3498DB',
              color: TP_COLORS.white,
            }}
          >
            JOIN NOW
          </ButtonBase>
        ) : null}
        {isCourseSubscribed && zoomData ? (
          <ZoomMeetingOptionsButtonWithMenu
            section={zoomData}
            onCancelClass={onCancelClass}
            isOneToOne={isOneToOne}
            onRescheduleClass={onRescheduleClass}
          />
        ) : null}
        {resourceData && resourceData.quiztopiyaResourceUrl ? (
          <ButtonBase
            href={`${process.env.PUBLIC_URL}/${resourceData.quiztopiyaResourceUrl}`}
            target="_blank"
            sx={{
              ...buttonBaseStyles,
              backgroundColor: '#1E293B',
              color: TP_COLORS.white,
            }}
          >
            View Resource
          </ButtonBase>
        ) : null}
      </Stack>
    </Stack>
  );
};

export default MixedSectionContent;
